// Components

// View
import Order from '../views/Order'
import Options from '../views/Options'
import Process from '../views/Process'
import Authentication from '../views/Authentication'
import Phone from '../views/Phone'

const routes = [
  {
    path: '/',
    name: 'order',
    title: 'Order',
    component: Order
  },
  {
    path: '/options',
    name: 'options',
    title: 'Options',
    component: Options
  },
  {
    path: '/process',
    name: 'process',
    title: 'Process',
    component: Process
  },
  {
    path: '/authentication',
    name: 'authentication',
    title: 'Authentication',
    component: Authentication
  },
  {
    path: '/phone',
    name: 'phone',
    title: 'Phone',
    component: Phone
  },
  {
    path: '*',
    redirect: { name: 'order' }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js